
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import MemoryDataTable from "@/components/wmc/MemoryDataTable.vue";
import { parseUrlPedidosFilter } from "./FiltroPedidosQueryParser";
import _ from "lodash";
import FiltroFinanceiroContainer from "@/components/financeiro/FiltroFinanceiroContainer.vue";
import { format } from "date-fns";
import UserService from "@/services/UserService";
import PagamentoService from "@/services/PagamentoService";
import { moneyFormatter } from "../utils";

const Notifications = namespace("Notifications");

const initialPaginacao = {
  itemsPerPage: 5,
  page: 1,
  sortBy: [],
  sortDesc: [],
  groupBy: [],
  groupDesc: [],
  mustSort: false,
  multiSort: false,
};

@Component({
  name: "ListaFinanceiro",
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MemoryDataTable,
    FiltroFinanceiroContainer,
  },
})
export default class ListaFinanceiro extends Vue {
  @Notifications.Action
  showErrorMessage!: (message: string) => Promise<any>;

  private paginacao = { ...initialPaginacao };
  private isLoading = false;

  private totalItens = 0;
  private valorTotal = 0;
  listaContas = [] as Array<any>;

  colunasTabela = [
    {
      // n do documento
      text: "N° Documento",
      align: "start",
      value: "nroNota",
      width: "5%",
      sortable: false,
    },
    {
      text: "Parcela",
      align: "start",
      value: "nrParcela",
      width: "2%",
    },
    {
      text: "Cliente",
      align: "start",
      value: "cliente",
      width: "15%",
    },
    {
      text: "Data Emissão",
      align: "start",
      value: "dataEmissao",
      width: "5%",
    },
    {
      text: "Data Vencimento",
      align: "start",
      value: "dataVencimento",
      width: "5%",
    },
    {
      text: "Situação",
      align: "center",
      value: "situacao",
      width: "5%",
      sortable: false,
    },
    {
      text: "Forma Pagamento",
      align: "start",
      value: "portadorDesc",
      width: "10%",
    },
    {
      text: "Valor Total",
      align: "start",
      value: "valor",
      width: "10%",
    },
    {
      text: "Banco",
      align: "start",
      value: "nroBanco",
      width: "10%",
      visible: false,
    },
    {
      text: "Nosso Número",
      align: "start",
      value: "nossoNumero",
      width: "10%",
      visible: false,
    },
    {
      text: "Linha Digitável",
      align: "start",
      value: "linhaDigitavel",
      width: "10%",
      visible: true,
    },
    {
      text: "Ações",
      align: "end",
      value: "acoes",
      width: "1%",
      sortable: false,
    },
  ];

  situacaoColor = {
    ABERTA: "green",
    PARCELADA: "orange",
    PAGA: "blue",
  };

  @Watch("paginacao")
  onPaginacaoChanged(value: any, oldValue: any) {
    if (!_.isEqual(value, oldValue)) {
      this.$router.push({
        query: { ...this.$router.currentRoute.query, ...value },
      });
    }
  }
  constructor() {
    super();
    this.paginacao =
      parseUrlPedidosFilter(this.$router.currentRoute.query, this.$props.admin)
        .pagination || initialPaginacao;
  }

  mounted() {
    this.buscarDadosAPI();
  }

  async onEmitirBoleto(item: any) {
    const url = await PagamentoService.get_banco_url(
      item.nroBanco,
      item.bancoDesc
    );
    if (url) window.open(url, "_blank");
    if (!url) {
      this.showErrorMessage("Não foi possível encontrar o banco para o boleto");
    }
  }

  getSituacaoColor(pedido: any) {
    const today = new Date();
    const situacao = pedido?.situacao?.trim().toUpperCase();

    // se a data de vencimento foi menor que a data atual fica vermelho
    if (pedido?.dataVencimento && new Date(pedido?.dataVencimento) < today) {
      return "red darken-2";
    } else {
      return "yellow darken-2";
    }
  }

  formatMoney(value: number) {
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  get valorTotalPedsFormatted() {
    return moneyFormatter(this.valorTotal);
  }

  async buscarDadosAPI(resetPage = false) {
    this.isLoading = true;
    const params = parseUrlPedidosFilter(
      this.$router.currentRoute.query,
      this.$props.admin
    );
    const { pagination, filter } = params;

    UserService.financeiro({ pagination: pagination as any, filter })
      .then((resp: any) => {
        this.totalItens = resp?.count || 0;
        this.valorTotal = resp?.valorTotal || 0;
        this.listaContas = resp?.data || [];

        this.isLoading = false;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  formatData(valor: any) {
    if (!valor) return "";
    const dateVal = new Date(valor);
    return format(dateVal, "dd/MM/yyyy");
  }
}
